export default __webpack_public_path__ + "static/add@992-9af43109ca21bf878f4385faa165c89e.svg";